import React, { useRef, useEffect, useCallback, useState} from 'react';
import {useTransformationTooltip} from './useTransformationTooltip.js';
import {useEdgeDragging} from "components/groups/useEdgeDragging.js";
import TransformationTooltip from "components/groups/TransformationTooltip.js";
import {useGroupPos} from './useGroupPos.js';
import {useGroupStyle} from './useGroupStyle.js';
import {MARKOV} from "pattern/groups/transformations.js";
import {shouldTransform} from 'pattern/groups/stepGroups.js';
import {
    setStepsGroupMode,
    setTransformationEdgeDragging,
    setSelectedPianoRollSteps} from 'actions/index.js';
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';

const colors = new Colors();

const Group = ({
    setTransformationEdgeDragging,
    trackSteps,
    group,
    track,
    setSelectedPianoRollSteps,
    selectedPianoRollSteps,
    setStepsGroupMode,
    showEffects,
    container,
    scale
}) => { 
    let {pos} = useGroupPos({container, group, track, trackSteps, scale});
    let {style, className, selected} = useGroupStyle({group, pos, selectedPianoRollSteps});
    let {startDragging, endDragging} = useEdgeDragging({track, setTransformationEdgeDragging});
    let {showTooltip, setShowTooltip, onMouseOver, onMouseLeave} = useTransformationTooltip();

    const onClickGroup = useCallback(() => {
        setSelectedPianoRollSteps(selected ? [] : group.steps);
        setStepsGroupMode(true);
    }, [selected]);

    useEffect(() => {
        return () => {
            if (track.isEffectsShowing() || track.isHidden()) {
                setStepsGroupMode(false);
            }
        };
    }, []);

    return (
        <div
          id={"steps-group-" + group.id}
          onClick={onClickGroup}
          style={style} className={className}>
          {isNaN(style.left) ? '' : 
           <span className="group-name">{group.name.split(" ")[1]}</span>}
          {isNaN(style.left) ? '' : 
           <div className="transformations">
             {group.transformations.map(
                 t =>
                     <div
                       key={t.id}
                       className="transformation-wrapper"
                       onMouseOver={(e) => onMouseOver(e, t)}
                       onMouseLeave={onMouseLeave}
                     >
                     <div
                       onMouseUp={() => {
                           endDragging(t);
                           onClickGroup();
                       }}
                       onMouseDown={() => startDragging(t)}
                       id={"transformation-" + t.id}
                       className={shouldTransform(t) ? "transforming transformation" : "transformation"}>
                     </div>
                       {showTooltip === t ? <TransformationTooltip track={track} transformation={t}/> : ''}
                     </div>)}
           </div>}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      selectedPianoRollSteps: state.keyboard.selectedPianoRollSteps,
      numTransformations: props.group.transformations.length
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedPianoRollSteps: (x) => dispatch(setSelectedPianoRollSteps(x)),
      setTransformationEdgeDragging: (x) => dispatch(setTransformationEdgeDragging(x)),
      setStepsGroupMode: (x) => dispatch(setStepsGroupMode(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Group);
